import { Auth } from "shared/@auth";

import React, { useEffect, useState } from "react";
import styles from "./index.module.css";

import { Section } from "shared/layout";

import AlertNotice from "shared/AlertNotice";
import { Danger } from "react-ikonate";

import { Form } from "shared/@forms/Form";
import TextInput from "shared/@forms/TextInput";
import EmailInput from "shared/@forms/EmailInput";

import Button, { ButtonPurpose } from "shared/Button";

export default function DreamStreamAdd({ data, onSubmit, membership }) {
  const [pinLevel, setPinLevel] = useState(0);

  const [contact, setContact] = useState({
    iboNumber: 0,
    wwgId: 0,
    name: "",
    email: "",
    pinLevel: 0,
  });
  const [isBusy, setIsBusy] = useState(false);

  const { hasPermission } = Auth.useContainer();
  const canAdd = hasPermission("dreamstream.sync") ? true : false;

  useEffect(() => {
    // console.log("*** useEffect - Add - data ***");
    // console.log(data);
    // console.log("************************");

    if (data) {
      setPinLevel(data.iboInfo.pinLevel);

      setContact({
        iboNumber: Number(data.iboNumber),
        wwgId: Number(data.wwgId),
        name: data.iboInfo.name,
        email: !data.iboInfo.email ? "" : data.iboInfo.email,
        type: data.iboInfo.type,
      });
    }
  }, [data]);

  return (
    <Section className={styles.mb1}>
      <Form
        onSubmit={(e) => {
          setIsBusy(true);
          onSubmit(contact);
        }}
      >
        <header>
          <h3>
            {contact.name} ({contact.type})
          </h3>
        </header>
        {!canAdd && pinLevel == 1 && (
          <AlertNotice icon={<Danger />} title="Not Available">
            <div className={styles.mb1}>
              Adding IBOs will be enabled when DreamStream is available to the
              entire organization.
            </div>
          </AlertNotice>
        )}

        {pinLevel == 4 && (
          <AlertNotice icon={<Danger />} title="Not Available">
            <div className={styles.mb1}>
              Adding Diamonds is disabled at this time. To add a Diamond, please
              contact Bret Dickey.
            </div>
          </AlertNotice>
        )}

        {((canAdd && pinLevel == 1) || pinLevel == 2 || pinLevel == 3) && (
          <div>
            <AlertNotice icon={<Danger />} title="No DreamStream Account Found">
              {membership && membership.status === "Active" ? (
                <>
                  {" "}
                  <div className={styles.mb1}>
                    {contact.name} does not have a DreamStream account. To add
                    you will need to provide a name and email address. The email
                    address must be unique.
                  </div>
                  <div>
                    {pinLevel === 1 && (
                      <div>
                        Clicking add will perform the following steps:
                        <br />
                        Step 1: Create DreamStream account
                        <br />
                        Step 2: Lookup LOA, Group & Pin Plugins
                        <br />
                        Step 3: Add to Upline Organizations & Groups <br />
                        Step 4: Verify DreamStream Account
                        <br />
                        Step 5: Send DreamStream Invite Email
                      </div>
                    )}

                    {pinLevel >= 2 && (
                      <div>
                        Step 1: Create DreamStream account
                        <br />
                        Step 2: Lookup LOA, Group & Pin Plugins
                        <br />
                        Step 3: Create Organization/Groups
                        <br />
                        Step 4: Add to Own Organization/Groups
                        <br />
                        Step 5: Sync Downline into Own Organization/Groups
                        <br />
                        Step 6: Add to Upline Organizations & Groups <br />
                        Step 7: Verify DreamStream Account
                        <br />
                        Step 8: Send DreamStream Invite Email
                      </div>
                    )}
                  </div>
                </>
              ) : (
                "Must have an active membership in order to add IBO."
              )}
            </AlertNotice>
            {membership.status === "Active" && (
              <>
                <div className={styles.splitGroup}>
                  <div className={styles.inputGroup}>
                    <label htmlFor="dreamStreamName">Name</label>
                    <TextInput
                      id="dreamStreamName"
                      required={true}
                      value={contact.name}
                      disabled={isBusy}
                      onChange={(e) => {
                        setContact({
                          ...contact,
                          name: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className={styles.inputGroup}>
                    <label htmlFor="dreamStreamEmail">Email</label>
                    <EmailInput
                      id="dreamStreamEmail"
                      required={true}
                      value={contact.email}
                      disabled={isBusy}
                      onChange={(e) => {
                        setContact({
                          ...contact,
                          email: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
                <div className={styles.actions}>
                  <Button
                    purpose={ButtonPurpose.save}
                    className={isBusy ? styles.hidden : ""}
                  >
                    Add
                  </Button>
                </div>
              </>
            )}
          </div>
        )}
      </Form>
    </Section>
  );
}
